module.exports = __webpack_public_path__ + "img/icon_search_dell.df06c39c.png";